
(function(){
  "use strict";
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Nav scroll ---- */
  var nav = document.getElementById('nav');
  var burger = document.getElementById('burger');
  if(nav){
    var onScroll = function(){ nav.classList.toggle('scrolled', window.scrollY > 40); };
    onScroll(); window.addEventListener('scroll', onScroll, {passive:true});
  }

  /* ---- Mobile drawer ---- */
  var drawer = document.getElementById('mDrawer');
  function setMenu(open){
    if(!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('nav-locked', open);
    if(burger) burger.setAttribute('aria-expanded', open);
  }
  if(burger){
    burger.addEventListener('click', function(){
      setMenu(!drawer.classList.contains('open'));
    });
  }
  if(drawer){
    // close on: X button, backdrop tap, or any link tap inside the panel
    drawer.addEventListener('click', function(e){
      if(e.target.closest('[data-close]') || e.target.closest('#mDrawerClose') || e.target.closest('a')){
        setMenu(false);
      }
    });
  }
  // Escape closes; growing back to desktop closes + unlocks scroll
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && drawer && drawer.classList.contains('open')){ setMenu(false); }
  });
  window.addEventListener('resize', function(){
    if(window.innerWidth > 760 && drawer && drawer.classList.contains('open')){ setMenu(false); }
  });

  /* ---- Reveal on scroll ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if(reduce || !('IntersectionObserver' in window)){
    revealEls.forEach(function(el){ el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {threshold:0.12, rootMargin:'0px 0px -8% 0px'});
    revealEls.forEach(function(el){ io.observe(el); });
  }

  /* ---- Count-up stats ---- */
  function animateCount(el){
    var target = parseFloat(el.getAttribute('data-count'));
    var isFloat = target % 1 !== 0;
    var unit = el.querySelector('.u');
    var unitHTML = unit ? unit.outerHTML : '';
    if(reduce){ el.innerHTML = (isFloat?target.toFixed(1):target) + unitHTML; return; }
    var start = null, dur = 1400;
    function step(ts){
      if(!start) start = ts;
      var p = Math.min((ts-start)/dur, 1);
      var eased = 1 - Math.pow(1-p, 3);
      var val = target * eased;
      el.innerHTML = (isFloat ? val.toFixed(1) : Math.floor(val)) + unitHTML;
      if(p<1) requestAnimationFrame(step);
      else el.innerHTML = (isFloat?target.toFixed(1):target) + unitHTML;
    }
    requestAnimationFrame(step);
  }
  var counted = false;
  var statSection = document.querySelector('.stat-grid');
  if(statSection){
    var co = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting && !counted){
          counted = true;
          document.querySelectorAll('.num[data-count]').forEach(animateCount);
        }
      });
    }, {threshold:0.4});
    co.observe(statSection);
  }

  /* ---- Ride modes ---- */
  var modeData = [
    {name:'ECO', desc:'Stretch every electron. Eco mode softens throttle response and caps output for the longest possible range — perfect for long exploration days.', range:'150 km', power:'Gentle', resp:'Smooth', r:100, p:35, t:30},
    {name:'STANDARD', desc:'The everyday sweet spot. Balanced power and range for confident riding in any conditions, road or trail.', range:'120 km', power:'Balanced', resp:'Linear', r:78, p:62, t:60},
    {name:'SPORT', desc:'Everything, right now. Sport mode unlocks the full 35kW and 948 Nm for explosive, race-level acceleration.', range:'80 km', power:'Maximum', resp:'Instant', r:48, p:100, t:100},
    {name:'OFF-ROAD', desc:'Trail-tuned traction. Power delivery calibrated for loose surfaces, climbs and technical terrain with maximum control.', range:'80 km', power:'Aggressive', resp:'Controlled', r:48, p:88, t:78}
  ];
  var tabs = document.querySelectorAll('.mode-tab');
  var pName=document.getElementById('pName'), pDesc=document.getElementById('pDesc'),
      vRange=document.getElementById('vRange'), vPower=document.getElementById('vPower'), vResp=document.getElementById('vResp'),
      barRange=document.getElementById('barRange'), barPower=document.getElementById('barPower'), barResp=document.getElementById('barResp');
  function setMode(i){
    var d = modeData[i];
    tabs.forEach(function(t,idx){ t.classList.toggle('active', idx===i); });
    pName.textContent=d.name; pDesc.textContent=d.desc;
    vRange.textContent=d.range; vPower.textContent=d.power; vResp.textContent=d.resp;
    barRange.style.width=d.r+'%'; barPower.style.width=d.p+'%'; barResp.style.width=d.t+'%';
  }
  if(pName && tabs.length){
    tabs.forEach(function(t){ t.addEventListener('click', function(){ setMode(parseInt(t.getAttribute('data-mode'),10)); }); });
    setMode(0);
  }

  /* ---- Feature video ---- */
  var vPoster = document.getElementById('vPoster');
  var featVid = document.getElementById('featVid');
  if(vPoster && featVid){
    vPoster.addEventListener('click', function(){
      vPoster.style.display='none';
      featVid.play();
    });
  }

  /* ---- Gallery lightbox ---- */
  var galImgs = Array.prototype.slice.call(document.querySelectorAll('#gal .gitem img'));
  var lb=document.getElementById('lightbox'), lbImg=document.getElementById('lbImg'),
      lbClose=document.getElementById('lbClose'), lbPrev=document.getElementById('lbPrev'), lbNext=document.getElementById('lbNext');
  var cur=0;
  function openLb(i){ cur=i; lbImg.src=galImgs[i].src; lbImg.alt=galImgs[i].alt; lb.classList.add('on'); document.body.style.overflow='hidden'; }
  function closeLb(){ lb.classList.remove('on'); document.body.style.overflow=''; }
  function nav2(d){ cur=(cur+d+galImgs.length)%galImgs.length; lbImg.src=galImgs[cur].src; lbImg.alt=galImgs[cur].alt; }
  if(lb && lbClose && lbPrev && lbNext && galImgs.length){
    galImgs.forEach(function(img,i){ img.parentElement.addEventListener('click', function(){ openLb(i); }); });
    lbClose.addEventListener('click', closeLb);
    lbPrev.addEventListener('click', function(){ nav2(-1); });
    lbNext.addEventListener('click', function(){ nav2(1); });
    lb.addEventListener('click', function(e){ if(e.target===lb) closeLb(); });
    document.addEventListener('keydown', function(e){
      if(!lb.classList.contains('on')) return;
      if(e.key==='Escape') closeLb();
      else if(e.key==='ArrowLeft') nav2(-1);
      else if(e.key==='ArrowRight') nav2(1);
    });
  }

  /* ---- Spec accordion ---- */
  document.querySelectorAll('.acc-head').forEach(function(btn){
    btn.addEventListener('click', function(){
      var acc = btn.parentElement;
      var body = btn.nextElementSibling;
      var open = acc.classList.toggle('open');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : 0;
    });
  });
  // open the first accordion by default
  document.querySelectorAll('.acc.open .acc-body').forEach(function(b){ b.style.maxHeight = b.scrollHeight + 'px'; });

  /* ---- Hero video fallback ---- */
  var hv = document.querySelector('.hero video');
  if(hv){
    hv.addEventListener('error', function(){
      hv.style.display='none';
      var fb=document.querySelector('.hero-fallback'); if(fb) fb.style.display='block';
    });
  }

  /* ---- Product page: colour swatches + variant picker + thumbs ---- */
  (function(){
    var form = document.getElementById('pForm');
    var sel = document.getElementById('pVariant');
    var groups = Array.prototype.slice.call(document.querySelectorAll('.opt-values'));
    var priceEl = document.getElementById('pPrice');
    var atc = form ? form.querySelector('.product-atc') : null;
    var atcLabel = atc ? atc.querySelector('.atc-label') : null;
    var main = document.getElementById('pMainImg');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pthumb'));
    var showImage = function(src){
      if(!src) return;
      if(main) main.src = src;
      thumbs.forEach(function(t){ t.classList.toggle('active', t.getAttribute('data-full') === src); });
    };
    if(form && sel && groups.length){
      var selectedCombo = function(){
        return groups.map(function(g){
          var a = g.querySelector('.opt-swatch.active');
          return a ? a.getAttribute('data-value') : null;
        }).join(' / ');
      };
      var sync = function(jumpImage){
        var combo = selectedCombo();
        var opts = Array.prototype.slice.call(sel.options);
        var match = opts.filter(function(o){ return o.getAttribute('data-opts') === combo; })[0];
        if(match){
          sel.value = match.value;
          if(priceEl && match.getAttribute('data-price')) priceEl.textContent = match.getAttribute('data-price');
          if(atc){
            atc.disabled = match.disabled;
            if(atcLabel) atcLabel.textContent = match.disabled ? 'Sold out' : 'Buy now';
          }
          /* jump the main photo to this colour's image */
          if(jumpImage) showImage(match.getAttribute('data-img'));
        }
      };
      groups.forEach(function(g){
        g.addEventListener('click', function(e){
          var b = e.target.closest('.opt-swatch');
          if(!b || b.disabled) return;
          g.querySelectorAll('.opt-swatch').forEach(function(s){ s.classList.remove('active'); });
          b.classList.add('active');
          sync(true);
        });
      });
      sync(false);
    }
    /* image thumbnails (manual click) */
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){ showImage(t.getAttribute('data-full')); });
    });
  })();
})();
